import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { ProfileCompletionGuard } from './guards/profile-completion.guard';
import { ListingProxyComponent } from './pages/proxy/listing-proxy/listing-proxy.component';
import { DefaultProxyComponent } from './components/default-proxy/default-proxy.component';
import { PlaygroundComponent } from './shared/x-kit/playground/playground.component';
import { GotoProxyComponent } from './components/goto-proxy/goto-proxy.component';
import { OnDemandPreloadStrategy } from './on-demand-preloading-strategy';
import { ProjectDashboardComponent } from './pages/projects/project-dashboard/project-dashboard.component';
import { PolygonPrintComponent } from './pages/polygon-print/polygon-print.component';

const routes: Routes = [
  { path: '', redirectTo: 'guest', pathMatch: 'full' },
  { path: 'playground', component: PlaygroundComponent },
  {
    path: 'design-tokens',
    loadComponent: () =>
      import('./pages/design-tokens/design-tokens.component').then((m) => m.DesignTokensComponent),
  },
  { 
    path: 'widgets-demo', 
    loadComponent: () => import('./pages/widgets-demo/widgets-demo.component').then(m => m.WidgetsDemoComponent)
  },
  { path: 'map', redirectTo: 'guest', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'board-join/:board_id/:listing_id',
    component: ListingProxyComponent,
  },
  {
    path: 'goto/:goto_uuid',
    component: GotoProxyComponent,
  },
  {
    path: 'guest',
    component: DefaultProxyComponent,
    children: [
      {
        path: '',
        redirectTo: 'map',
        pathMatch: 'full',
      },
      {
        path: 'map',
        loadChildren: () => import('./pages/dp-map/dp-map.module').then((m) => m.DpMapModule),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'projects',
    canActivate: [AuthGuard, ProfileCompletionGuard],
    loadChildren: () => import('./pages/projects/projects.routes').then((m) => m.PROJECT_ROUTING),
  },
  {
    path: 'project/:project_id',
    canActivate: [AuthGuard, ProfileCompletionGuard],
    children: [
      {
        path: '',
        redirectTo: 'workspace',
        pathMatch: 'full',
      },
      {
        path: 'board/:uid',
        loadChildren: () => import('./pages/dp-map/dp-map.module').then((m) => {
          return m.DpMapModule
        }),
      },
      {
        path: 'workspace-agent/:uid',
        loadChildren: () => import('./pages/dp-map/dp-map.module').then((m) => {
          return m.DpMapModule
        }),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/legal/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./pages/legal/terms-of-service/terms-of-service.component').then((m) => m.TermsOfServiceComponent),
  },
  {
    path: 'dashboard-export/:token/:projectId/:dashboardId/:reportId',
    component: ProjectDashboardComponent,
    // Public route - no AuthGuard, token in URL provides access
    data: { exportMode: 'pdf' },
  },
  {
    path: 'dashboard-map/:token/:projectId/:dashboardId/:reportId',
    component: ProjectDashboardComponent,
    // Public route - no AuthGuard, token in URL provides access
    data: { exportMode: 'map' },
  },
  {
    path: 'dashboard-export-data/:sessionId',
    component: ProjectDashboardComponent,
    // Public route - no AuthGuard, data comes from sessionStorage
    data: { exportMode: 'pdf', dataSource: 'session' },
  },
  {
    path: 'polygon-print/:sessionId',
    component: PolygonPrintComponent,
    // Public route - no AuthGuard, data comes from sessionStorage
    data: { exportMode: 'pdf', dataSource: 'session' },
  },
  {
    path: '**',
    redirectTo: 'guest',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: OnDemandPreloadStrategy })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
